import React from 'react';
import { ChangeEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { isFunction } from '@philips-internal/oswald-ui-utils';
import './native-select.css';
function NativeSelect(props) {
    const { data = [], onChange, value = { key: '' } } = props;
    if (!Array.isArray(data)) {
        return null;
    }
    const onChangeHandler = (event) => {
        if (!isFunction(onChange)) {
            return;
        }
        onChange(new ChangeEvent({
            oldValue: value,
            value: data.find((item) => item.key === event.target.value),
        }));
    };
    return (React.createElement("select", { className: "c-native-select", onChange: onChangeHandler, value: value.key || '' },
        React.createElement("option", { value: "" }),
        data.map(({ key, label }) => (React.createElement("option", { key: key, value: key }, label)))));
}
export { NativeSelect, };
//# sourceMappingURL=native-select.js.map